import { render, staticRenderFns } from "./TopWordsConfig.vue?vue&type=template&id=e9d9e7e6"
import script from "./TopWordsConfig.vue?vue&type=script&lang=js"
export * from "./TopWordsConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9d9e7e6')) {
      api.createRecord('e9d9e7e6', component.options)
    } else {
      api.reload('e9d9e7e6', component.options)
    }
    module.hot.accept("./TopWordsConfig.vue?vue&type=template&id=e9d9e7e6", function () {
      api.rerender('e9d9e7e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/Edit/QuestionConfig/TopWordsConfig.vue"
export default component.exports